import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {InsightsService} from "../../services/insights/insights.service";
import * as Highcharts from 'highcharts/highcharts';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {SolidgaugeChartService} from "../../services/solidgauge-chart/solidgauge-chart.service";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-pulse-participation-overall',
  templateUrl: './pulse-participation-overall.component.pug',
  styleUrls: ['./pulse-participation-overall.component.scss'],
  standalone: false
})
export class PulseParticipationOverallComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() filterBy!: any;
  @Input() request!: any;
  @Input() survey!: any;
  @Input() department!: any;
  @Input() defaultState!: string;
  @Output() selectionChange = new EventEmitter();
  @Output() dataLoaded = new EventEmitter<void>();
  data: any = []
  responded = 0
  declined = 0
  inProgress = 0
  unresponsive = 0
  updateResponded = false
  updateParticipated = false
  updateDeclined = false
  updateInProgress = false
  updateUnresponsive = false

  selected = '';
  Highcharts: typeof Highcharts = Highcharts;
  respondedChartOptions = SolidgaugeChartService.getOptions(this.responded, '#32735F', 'rgba(50,115,95,0.1)');
  declinedChartOptions = SolidgaugeChartService.getOptions(this.declined, '#DE8C02', 'rgba(222,140,2,0.1)');
  inProgressChartOptions = SolidgaugeChartService.getOptions(this.inProgress, '#000000', 'rgba(0,0,0,0.1)');
  unresponsiveChartOptions = SolidgaugeChartService.getOptions(this.unresponsive, '#000000', 'rgba(0,0,0,0.1)');

  constructor(
    private insightsService: InsightsService,
    private alertList: AlertBannerService
    )
  {
  }

  ngOnInit(): void {
    this.switchSelected(this.defaultState);
  }

  private loadAndSetData() {
    this.insightsService.getParticipationOverall(this.start, this.end, this.survey, this.filterBy, 'pulse', this.request, this.department).subscribe(data => {

      this.data = data;
      this.responded = this.declined = this.inProgress = this.unresponsive = 0;

      for (let d of this.data) {
        if (d['state'] === 'responded') {
          this.responded = d['participation']
        } else if (d['state'] === 'declined') {
          this.declined = d['participation']
        } else if ((d['state'] === 'in_progress')) {
          this.inProgress = d['participation']
        }else if (d['state'] === 'in progress') {
          this.inProgress = d['participation']
        } else if (d['state'] === 'unresponsive') {
          this.unresponsive = d['participation']
        }
      }

      this.respondedChartOptions = SolidgaugeChartService.getOptions(this.responded, '#32735F', 'rgba(50,115,95,0.1)');
      this.declinedChartOptions = SolidgaugeChartService.getOptions(this.declined, '#DE8C02', 'rgba(222,140,2,0.1)');
      this.inProgressChartOptions = SolidgaugeChartService.getOptions(this.inProgress, '#000000', 'rgba(0,0,0,0.1)');
      this.unresponsiveChartOptions = SolidgaugeChartService.getOptions(this.unresponsive, '#000000', 'rgba(0,0,0,0.1)');
      this.emitDataLoaded();
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      this.emitDataLoaded();
    });
  }

  switchSelected(selected: any) {
    // Deselect old
    switch (this.selected) {
      case "declined":
        if (this.declinedChartOptions && this.declinedChartOptions.chart) {
          this.updateDeclined = true;
        }
        break
      case "inProgress":
        if (this.inProgressChartOptions && this.inProgressChartOptions.chart) {
          this.updateInProgress = true;
        }
        break
      case "unresponsive":
        if (this.unresponsiveChartOptions && this.unresponsiveChartOptions.chart) {
          this.updateUnresponsive = true;
        }
        break
      default:
        if (this.respondedChartOptions && this.respondedChartOptions.chart) {
          this.updateResponded = true;
        }
    }

    this.selected = selected;
    // Select new
    switch (this.selected) {
      case "declined":
        if (this.declinedChartOptions && this.declinedChartOptions.chart) {
          this.declinedChartOptions.chart.backgroundColor = '';
          this.updateDeclined = true;
        }
        break
      case "inProgress":
        if (this.inProgressChartOptions && this.inProgressChartOptions.chart) {
          this.inProgressChartOptions.chart.backgroundColor = '';
          this.updateInProgress = true;
        }
        break
      case "unresponsive":
        if (this.unresponsiveChartOptions && this.unresponsiveChartOptions.chart) {
          this.unresponsiveChartOptions.chart.backgroundColor = '';
          this.updateUnresponsive = true;
        }
        break
      default:
        if (this.respondedChartOptions && this.respondedChartOptions.chart) {
          this.respondedChartOptions.chart.backgroundColor = '';
          this.updateResponded = true;
        }
    }

    this.selectionChange.emit(this.selected);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }

  private emitDataLoaded(): void {
    this.dataLoaded.emit();
  }
}
